import styled, { css } from 'styled-components'

const PRIMARY = 'primary'
const SECONDARY = 'secondary'

export const DropdownError = styled('span')`
  color: ${props =>
    props.variant === PRIMARY
      ? props.errorColor || 'var(--red)'
      : props.errorColor || 'var(--orange)'};
  padding-left: ${props => (props.variant === PRIMARY ? 'var(--base)' : '0px')};
  font-size: var(--xs);
`

// Container Size Styles
const smallContainer = css`
  width: var(--10xl);
`

const quantityContainer = css`
  width: var(--8xl);
`

const fullContainer = css`
  width: 100%;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`

// Header Size Styles
const smallHeader = css`
  padding-right: var(--1xs);
  padding-top: var(--xs);
  padding-bottom: var(--xs);
`

const quantityHeader = css`
  padding-right: var(--1xs);
  padding-top: var(--xs);
  padding-bottom: var(--xs);
`

// Input Container Styles

const resizedInput = css`
  & > p {
    transform: none;
  }
`

export const DropDownContainer = styled.div`
  display: flex;
  flex-direction: column;

  position: relative;
  width: var(--filter-width);
`

export const DropDownSubContainer = styled.div`
  * {
    margin: 0px;
    padding: 0px;
    box-sizing: border-box;
  }

  ${props =>
    props.variant === PRIMARY &&
    css`
      font-size: var(--sm);
      color: var(--black);
      width: var(--12xl);
      max-height: var(--6xl);
      transition: all 0.7s;
      border-radius: var(--2xs);

      @media only screen and (max-width: 768px) {
        width: var(--11xl);
      }

      ${props.open && 'box-shadow: var(--drop-shadow);'}
      ${props.size === 'small' && smallContainer}
      ${props.size === 'quantity' && quantityContainer}
      ${props.size === 'full' && fullContainer}
    `}
`

export const DropDownHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  background-color: var(--white);
  transition: all 0.7s;
  border: var(--5xs) solid ${props => props.borderColor || 'var(--grey-7)'};

  ${props =>
    props.variant === SECONDARY &&
    css`
      border-bottom: var(--5xs) solid ${'var(--clr-set-btn)' || 'var(--black)'};
      ${props.open &&
        `border-color: ${'var(--clr-set-btn)' || 'var(--black)'};`}

      ${props.validated &&
        css`
          border-bottom: var(--3xs) solid
            ${props.validatedColor || 'var(--green)'};
        `}

      ${props.error &&
        css`
          border: var(--5xs) solid ${props.errorColor || 'var(--orange)'};
          border-bottom: var(--3xs) solid ${props.errorColor || 'var(--orange)'};
        `}
    `}

  ${props =>
    props.variant === PRIMARY &&
    css`
      & > span {
        flex: 1 1 0%;
        padding-right: var(--base);
      }

      ${props.open
        ? css`
            border-color: ${'var(--clr-set-btn)' || 'var(--grey-5)'};
            border-width: var(--4xs);
            border-top-left-radius: var(--2xs);
            border-top-right-radius: var(--2xs);
          `
        : 'border-radius: var(--2xs);'}

      ${props.error &&
        css`
          border-color: ${props.errorColor || 'var(--red)'};
          border-width: var(--4xs);
        `}

      background-color: var(--white);
      padding-left: var(--base);
      padding-top: var(--base);
      padding-bottom: var(--base);
      padding-right: var(--1xs);

      ${props.size === 'small' && smallHeader}
      ${props.size === 'quantity' && quantityHeader}
    `}
`

export const DropDownIconContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: var(--1xs);

  ${props =>
    props.variant === SECONDARY &&
    css`
      padding-top: var(--2xs);
      padding-bottom: var(--2xs);
      padding-right: var(--1xs);
    `}

  & > :last-child {
    transition: all 0.7s;
    ${props =>
      props.variant === PRIMARY
        ? props.open && 'transform: rotate(180deg);'
        : props.open &&
          !props.validated &&
          !props.error &&
          'transform: rotate(180deg);'}
  }
`

export const DropDownListContainer = styled('div')`
  background-color: var(--white);
  position: absolute;
  overflow-y: scroll;
  max-height: 0px;
  width: 100%;
  transition: all 0.7s;

  ${props =>
    props.variant === PRIMARY &&
    css`
      border-radius: 0px 0px 6px 6px;
      top: var(--6xl);
    `}

  ::-webkit-scrollbar {
    display: none;
  }

  ${props =>
    props.variant === SECONDARY &&
    css`
      border: ${props.open ? `var(--5xs) solid var(--grey-7)` : 'none'};
      top: var(--7xl);
    `}

  max-height: ${props => props.open && '230px'};
  ${props => props.open && `box-shadow: var(--drop-shadow);`}
  z-index: 20;
`

export const DropDownList = styled('ul')`
  list-style: none;
  padding: 0px;
`
export const ListItem = styled('li')`
  padding-left: var(--base);
  padding-top: var(--3xs);
  padding-bottom: var(--3xs);

  &:hover {
    background-color: var(--grey-8);
  }
`

export const DropdownInputContainer = styled('div')`
  position: relative;
  width: 100%;

  & > span {
    ${props =>
      props.variant === PRIMARY
        ? css`
            transition: all 0.5s;
            position: absolute;
            top: 0px;
            left: 0px;
            right: 0px;
          `
        : css`
            font-weight: 700;
          `}
  }

  ${props =>
    props.variant === PRIMARY &&
    css`
      & > p {
        transition: all 0.5s 0.4s;
        opacity: 0;
        width: 100%;
      }

      ${(props.open || props.touched) &&
        css`
          & > span {
            color: ${'var(--clr-set-btn)' || 'var(--black)'};
            top: -var(--xs);
            font-size: var(--xs);
          }

          & > p {
            opacity: 1;
            transform: translateY(5px);
          }
        `}
      ${props.touched &&
        css`
          & > span {
            color: ${'var(--clr-set-btn)' || 'var(--black)'};
          }
        `}
    `}

  ${props =>
    props.variant === SECONDARY &&
    css`
      display: flex;
      gap: var(--3xs);
      padding: var(--1xs) var(--xs);
    `}

  ${props =>
    (props.size === 'small' || props.size === 'quantity') && resizedInput}
`

export const LabelContainer = styled.p`
  margin: 0px;
  font-size: var(--dropdown-label-size);
  padding-bottom: var(--1xs);
`



// WEBPACK FOOTER //
// ./src/components/Dropdown/styles.js